import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';

import { completeOrderSelector } from 'selectors/order-create';

import Card from 'components/common/Card';
import { StepTitle, ContentContain, Button, StepInformation } from '../CreateStyled';
import OrderListItem from 'routes/Orders/OrderListItem';

export const StepComplete = ({ order }) => {
  const history = useHistory();

  const handleNavigateOrder = () => {
    history.replace(`/orders/${order.id}`);
  };

  const renderNext = () => <Button onClick={handleNavigateOrder}>View Order</Button>;

  return (
    <Card.Content>
      <ContentContain>
        <StepTitle>Order Created</StepTitle>
        <StepInformation>Your order has successfully been created</StepInformation>

        <OrderListItem
          border
          {...(order || {})}
          renderRight={renderNext}
          onClick={handleNavigateOrder}
        />
      </ContentContain>
    </Card.Content>
  );
};

export default connect(
  (state) => ({
    completedOrder: completeOrderSelector(state),
  }),
  {})(props => <StepComplete {...props} order={props.completedOrder} />
);

